import { render, staticRenderFns } from "./FacebookFees.vue?vue&type=template&id=519a5397&"
import script from "./FacebookFees.vue?vue&type=script&lang=js&"
export * from "./FacebookFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports